import { render } from "./StatusContent.vue?vue&type=template&id=23c04ce8&scoped=true&ts=true"
import script from "./StatusContent.vue?vue&type=script&lang=ts"
export * from "./StatusContent.vue?vue&type=script&lang=ts"

import "./StatusContent.vue?vue&type=style&index=0&id=23c04ce8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c04ce8"]])

export default __exports__